/**
 * クロス商品設定用VOクラス
 *
 * @export KYMW4802OutputModel
 * @class KYMW4802OutputModel
 */
export class KYMW4802OutputModel {
  /** Pコードリスト */
  public pcodeList: string[] = [];
}
